import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login/Login'
import ResetPassword from '../views/Login/ResetPassword'
import ChangePassword from '../views/Login/ChangePassword'
import Contact from '../views/Contact/FormContact'

import AdminDashBoard from '../views/Admin/index'
import AdminListCompany from '../views/Admin/Company/List'
import AdminAddCompany from '../views/Admin/Company/Add'
import AdminDetailCompany from '../views/Admin/Company/Detail'
import AdminDetailCompanyDashboard from '../views/Admin/Company/Dashboard'
import AdminDetailCompanyFolder from '../views/Admin/FolderManagement/List'
import AdminFileDetail from '../views/Admin/FolderManagement/FileDetail'
import AdminEditCompany from '../views/Admin/Company/Edit'
import AdminDeleteCompany from '../views/Admin/Company/Delete'
import AdminListEmployee from '../views/Admin/Company/Employee/List'
import AdminAddEmployee from '../views/Admin/Company/Employee/Add'
import AdminDetailEmployee from '../views/Admin/Company/Employee/Detail'
import AdminEditEmployee from '../views/Admin/Company/Employee/Edit'
import AdminDeleteEmployee from '../views/Admin/Company/Employee/Delete'
import AdminDetailMyPage from '../views/Admin/MyPage/Detail'
import AdminEditMyPage from '../views/Admin/MyPage/Edit'
import AdminListRequest from '../views/Admin/Request/List'
import AdminDetailRequest from '../views/Admin/Request/Detail'
import AdminDeleteRequest from '../views/Admin/Request/Delete'
import Error from '../views/Error'

import ManagerDashBoard from '../views/Manager/index'
import ManagerListEmployee from '../views/Manager/EmployeeManager/List'
import ManagerAddEmployee from '../views/Manager/EmployeeManager/Add'
import ManagerDetailEmployee from '../views/Manager/EmployeeManager/Detail'
import ManagerEditEmployee from '../views/Manager/EmployeeManager/Edit'
import ManagerDeleteEmployee from '../views/Manager/EmployeeManager/Delete'
import ManagerDetailMyPage from '../views/Manager/MyPage/DetailMypage'
import ManagerEditMyPage from '../views/Manager/MyPage/EditMypage'
import ManagerDetailCompany from '../views/Manager/Company/Detail'
import ManagerEditCompany from '../views/Manager/Company/Edit'
import ManagerFile from '../views/Manager/FolderManager/List'
import ManagerFavorite from '../views/Manager/MyPage/FavoriteMypage'
import ManagerHistory from '../views/Manager/MyPage/HistoryMypage'
import ManagerSearchFile from '../views/Manager/FolderManager/SearchFile'
import ManagerFileDetail from '../views/Manager/FolderManager/FileDetail'
import ManagerFolderDetail from '../views/Manager/FolderManager/FolderDetail'
import ManagerSearchResult from '../views/Manager/FolderManager/SearchResult'
import ManagerSettingNotification from '../views/Manager/MyPage/SettingNotification'

import EmployeeDashBoard from '../views/Employee/index'
import EmployeeMyPage from '../views/Employee/MyPage/DetailMypage'
import EmployeeEditMyPage from '../views/Employee/MyPage/EditMypage'
import EmployeeDetailCompany from '../views/Employee/Company/Detail'
import EmployeeFile from '../views/Employee/FolderManager/List'
import EmployeeFavorite from '../views/Employee/MyPage/FavoriteMypage'
import EmployeeHistory from '../views/Employee/MyPage/HistoryMypage'
import EmployeeSettingNotification from '../views/Employee/MyPage/SettingNotification'
import DetailEmployeeFile from '../views/Employee/FolderManager/FileDetail'

import Token401 from '../views/Token401'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: {requiresVisitor: true}
  },
  {
    path: '/login',
    component: Login,
    meta: {requiresVisitor: true}
  },
  {
    path: '/password_reset',
    name: 'reset_password',
    component: ResetPassword,
    meta: {requiresVisitor: true}
  },
  {
    path: '/reset/me/:token',
    name: 'change_password',
    component: ChangePassword,
    meta: {requiresVisitor: true}
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {requiresVisitor: true}
  },
  {
    path: '/admin/dashboard',
    name: 'admin_dashboard',
    component: AdminDashBoard,
    meta: {requiresVisitor: true}
  },
  {
    path: '/admin/companies',
    name: 'admin_companies',
    component: AdminListCompany,
    meta: {requiresVisitor: true}
  },
  {

    path: '/admin/companies/:id/dashboard',
    name: 'admin_companies_dashboard',
    component: AdminDetailCompanyDashboard,
    meta: {requiresVisitor: true}
  },
  {
    path: '/admin/companies/add',
    name: 'admin_add_companies',
    component: AdminAddCompany,
    meta: {requiresVisitor: true}
  },
  {
    path: '/admin/companies/:id/infor',
    name: 'admin_companies_detail',
    component: AdminDetailCompany,
    meta: {requiresVisitor: true}
  },
  {
    path: '/admin/companies/edit/:id',
    name: 'admin_companies_edit',
    component: AdminEditCompany,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/companies/delete',
    name: 'admin_companies_delete',
    component: AdminDeleteCompany,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/companies/:id/employees',
    name: 'admin_employees',
    component: AdminListEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/companies/:id/items/:folder_id',
    name: 'admin_folders',
    component: AdminDetailCompanyFolder,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/companies/:id/files/:file_id',
    name: 'admin_file_detail',
    component: AdminFileDetail,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/employees/add',
    name: 'admin_employees_add',
    component: AdminAddEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/companies/:id/employees/:employee_id',
    name: 'admin_employees_detail',
    component: AdminDetailEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/employees/edit',
    name: 'admin_employees_edit',
    component: AdminEditEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/employees/delete',
    name: 'admin_employees_delete',
    component: AdminDeleteEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/me',
    name: 'admin_me',
    component: AdminDetailMyPage,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/me/edit',
    name: 'admin_me_edit',
    component: AdminEditMyPage,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/requests',
    name: 'admin_request',
    component: AdminListRequest,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/requests/:id',
    name: 'admin_request_detail',
    component: AdminDetailRequest,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/requests/delete',
    name: 'admin_request_delete',
    component: AdminDeleteRequest,
    meta: {requiresAuth: true}
  },
  {
    path: '/404',
    name: 'error',
    component: Error,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/dashboard',
    name: 'manager_dashboard',
    component: ManagerDashBoard,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/items/:id',
    name: 'manager_items',
    component: ManagerFile,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/me/favorite',
    name: 'manager_favorite',
    component: ManagerFavorite,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/me/history',
    name: 'manager_history',
    component: ManagerHistory,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/me/setting',
    name: 'manager_setting',
    component: ManagerSettingNotification,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/employees',
    name: 'manager_employee',
    component: ManagerListEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/employees',
    name: 'manager_employee_add',
    component: ManagerAddEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/employees/:id',
    name: 'manager_employee_detail',
    component: ManagerDetailEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/employees/',
    name: 'manager_employee_edit',
    component: ManagerEditEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/employees/delete',
    name: 'manager_employee_delete',
    component: ManagerDeleteEmployee,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/me',
    name: 'manager_me',
    component: ManagerDetailMyPage,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/me/edit',
    name: 'manager_me_edit',
    component: ManagerEditMyPage,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/company',
    name: 'manager_company',
    component: ManagerDetailCompany,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/company/edit',
    name: 'manager_company_edit',
    component: ManagerEditCompany,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/search/file',
    name: 'manager_file_search',
    component: ManagerSearchFile,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/file/:id',
    name: 'manager_file_detail',
    component: ManagerFileDetail,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/folder/detail',
    name: 'manager_folder_detail',
    component: ManagerFolderDetail,
    meta: {requiresAuth: true}
  },
  {
    path: '/manager/search/result',
    name: 'manager_search_result',
    component: ManagerSearchResult,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/dashboard',
    name: 'employee_dashboard',
    component: EmployeeDashBoard,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/company',
    name: 'employee_company',
    component: EmployeeDetailCompany,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/items/:id',
    name: 'employee_file',
    component: EmployeeFile,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/me',
    name: 'employee_me',
    component: EmployeeMyPage,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/me/edit',
    name: 'employee_me_edit',
    component: EmployeeEditMyPage,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/me/favorite',
    name: 'employee_me_favorite',
    component: EmployeeFavorite,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/me/history',
    name: 'employee_me_history',
    component: EmployeeHistory,
    meta: {requiresAuth: true}
  },
  {

    path: '/employee/me/setting',
    name: 'employee_me_setting',
    component: EmployeeSettingNotification,
    meta: {requiresAuth: true}
  },
  {
    path: '/employee/files/:id',
    name: 'employee_file_detail',
    component: DetailEmployeeFile,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/request/list',
    name: 'request_list',
    component: AdminListRequest,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/request/detail',
    name: 'request_detail',
    component: AdminDetailRequest,
    meta: {requiresAuth: true}
  },
  {
    path: '/401',
    name: '401',
    component: Token401,
    meta: {requiresAuth: true}
  }
]

const router = new Router({
  mode: 'history',
  routes
})
// router.beforeEach((to, from, next) => {
//   console.log(to, from, next)
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js